import React from 'react';
import { Typography, Divider } from '@mui/material';
import { SupportAgent, Logout as LogoutIcon } from '@mui/icons-material';
import Image from 'next/image';

import { FlexSX } from '@/styles/commonSXs';
import { ProfileMenuItemsWrapper, ProfileMenuItemWrapper } from '../styled';
import ProfileMenu from '@/components/biz/ProfileMenu';
import LangSimpleSwitch from '@/components/system/LangSimpleSwitch';
import { isTelegramMiniAppView } from '@/utils/checkRuntime';
import { getStaticAsset } from '@/utils/staticAsset';

interface UserMenuItemsProps {
  isLogin: boolean;
  isMobile: boolean;
  userMetaData: {
    name?: string;
    uid?: string;
  };
  theme: any;
  t: (key: string) => string;
  onLiveSupport: () => void;
  onLogout: () => void;
  onClose: () => void;
}

const UserMenuItems: React.FC<UserMenuItemsProps> = ({
  isLogin,
  isMobile,
  userMetaData,
  theme,
  t,
  onLiveSupport,
  onLogout,
  onClose,
}) => {
  const handleLiveSupport = () => {
    onLiveSupport();
    onClose();
  };

  const handleLogout = () => {
    onClose();
    onLogout();
  };

  const itemStyle = {
    margin: '0 8px',
    padding: '8px 16px',
    borderRadius: '4px',
    transition: 'all 0.3s ease-in-out',
    '&:hover': {
      backgroundColor: '#5933A080',
    },
  };

  return (
    <>
      {/* 用户信息区域 */}
      {isLogin && (
        <>
          <div
            className="flex items-center gap-2 mb-2"
            style={{ margin: '8px 16px' }}
          >
            {/* 左侧用户头像 */}
            <Image
              src={getStaticAsset('/assets/images/logo/profile-logo.png')}
              alt="Profile"
              width={32}
              height={32}
              className="rounded-full"
            />

            {/* 右侧用户信息 */}
            <div className="flex-1 min-w-0">
              <div className="text-base truncate text-left font-medium">
                {userMetaData.name || 'User'}
              </div>
              <div className="text-sm !text-gray-400 text-left">
                UID: {userMetaData.uid}
              </div>
            </div>
          </div>
          <Divider sx={{ margin: '8px 0' }} />
          <ProfileMenuItemsWrapper>
            <ProfileMenu />
          </ProfileMenuItemsWrapper>
          <Divider sx={{ margin: '8px' }} />
        </>
      )}

      {/* 客服支持 */}
      <ProfileMenuItemWrapper
        sx={FlexSX}
        onClick={handleLiveSupport}
        style={itemStyle}
      >
        <SupportAgent sx={{ opacity: 0.56 }} />
        <Typography variant={'subtitle2'} ml={1}>
          {t('live-support')}
        </Typography>
      </ProfileMenuItemWrapper>

      {/* 语言切换 */}
      {isMobile && (
        <ProfileMenuItemWrapper sx={FlexSX} style={itemStyle}>
          <LangSimpleSwitch iconSize="24px" />
        </ProfileMenuItemWrapper>
      )}

      {/* 退出登录 */}
      {isLogin && !isTelegramMiniAppView && (
        <>
          <Divider sx={{ margin: '8px' }} />
          <ProfileMenuItemWrapper
            sx={FlexSX}
            onClick={handleLogout}
            style={itemStyle}
          >
            <LogoutIcon sx={{ opacity: 0.56 }} />
            <Typography variant={'subtitle2'} ml={1}>
              {t('sign-out')}
            </Typography>
          </ProfileMenuItemWrapper>
        </>
      )}
    </>
  );
};

export default UserMenuItems;
